import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=ee72a4c4&scoped=true&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=ee72a4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee72a4c4",
  null
  
)

export default component.exports